import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';
import Masonry 				from 'react-masonry-component';

import AnniversaryLogo from '../common/_AnniversaryLogo.jsx';
import StoryCard from '../common/_StoryCard.jsx';
import HiddenScroll from '../common/_HiddenScroll.jsx';

export default class AnniversaryStories extends BLComponent {
	constructor (props, context) {
		super(props, context);

		let activeDay = blapp.models.get('activeDay');
		let tab = blapp.util.getUrlVars().w ? parseInt(blapp.util.getUrlVars().w-1) :-1;
		this.currentWeek = activeDay == 0 ? null : Math.ceil(activeDay/5)-1;
		this.publishDays = {
			0: 3,
			1: 8,
			2: 13,
			3: 19,
			4: 19
		}

		if( activeDay < this.publishDays[this.currentWeek])
			this.currentWeek = this.currentWeek -1;

		this.state = {
			tab: tab,
			activeDay: activeDay,
			page: 1,
			stories: [],
			nStories: 0,
			sort: 1
		};

		

		this.storiesPerPage = 20;

		this.masonryOptions = {transitionDuration: 0};

		this.storyPrompts = [
				{id: 0, option: 'Coming across BrickLink', placeholder: 'Kindly share your story about how you came across BrickLink, and how it has changed your interest in LEGO elements and sets.'}
			,	{id: 1, option: 'Finding friendship', placeholder: 'Please tell us about a time you found friendship on BrickLink, highlight the moment you interacted with them, and how you met in real life (if applicable).'}
			,	{id: 2, option: 'Buyer/seller story', placeholder: 'Everyone has a favorite BrickLink seller/buyer story. Can you share with us what your favorite story is?'}
			,	{id: 3, option: 'Hopes for future BrickLink', placeholder: 'What hopes do you have for BrickLink in the near future?'}
			//,	{id: 4, option: '#SameMold', placeholder: 'What hopes do you have for BrickLink in the near future?'}
		]	
	}

	componentDidMount()
	{
		if(this.state.activeDay > 0 && this.state.tab <= this.currentWeek || this.state.tab == 4 && this.currentWeek == 3)
			this.loadStories()
	}

	render() {
		return (
			<React.Fragment>
				{this.renderHeader()}
				<main className="main">
					<div className="main__content">
						{this.renderNav()}
						{this.renderContent()}
					</div>
				</main>
			</React.Fragment>
		);
	}

	renderHeader() {
		return (
			<header>
				<div className={"anniversary__main-header anniversary__main-header--stories text--center"}>
					<div className="anniversary__main-header-internal">
						<div className="anniversary__content-width anniversary__content-width--header">
							<AnniversaryLogo whiteBg classes="anniversary__main-header-logo anniversary__main-header-logo--stories anniversary-logo--med l-margin-bottom--xl l-block l-margin-x--auto"/>
							<div className="anniversary__stories-header">
								<h1 className="anniversary__main-header-title">20 Years of BrickLink Stories</h1>
								<p className="l-margin-bottom--xl">Travel down memory lane as we celebrate the <a href={blapp.url2.getAnniversaryAnnouncementUrl()} target="_blank">20th anniversary</a> of the creation of BrickLink. Here, you can read stories written by the AFOL community’s highlighting everything from how it all started to what the future holds.</p>
							</div>
						</div>
					</div>
				</div>
				
			</header>
		);
	}

	renderNav() {
		const storyPrompts = this.storyPrompts.filter(cat => cat.id <= this.currentWeek || cat.id == 4 && this.currentWeek==3)
		const tabs = storyPrompts.map(prompt => {
			return (
				<li className={"view-selector__item anniversary__content-tab anniversary__content-tab--story" + (this.state.tab == prompt.id ? ' view-selector__item--active' : '')} key={prompt.id}>
					<button className="view-selector__item-content" onClick={() => this.setState({tab: prompt.id, page:1}, ()=>this.loadStories())}>
						{prompt.option}
					</button>
				</li>
			);
		});

		return (
			this.currentWeek > 0 ?
			<section className="anniversary__content-nav-container anniversary__content-nav-container--stories">
				<HiddenScroll classes="anniversary__story-prompt-tabs">
					<ul className="view-selector">
						<li className={"view-selector__item anniversary__content-tab anniversary__content-tab--story" + (this.state.tab == -1 ? ' view-selector__item--active' : '')}>
							<button className="view-selector__item-content" onClick={() => this.setState({tab: -1, page:1}, ()=>this.loadStories())}>
								All stories
							</button>
						</li>
						{tabs}
					</ul>
				</HiddenScroll>
				<div className="anniversary__story-filter">
					<div>
						{this.state.nStories} {this.state.nStories != 1 ? "stories" : "story"}
					</div>
					<label>
						<span className="l-hide--small l-margin-right--sm">Sort by:</span>
						<select className="select select--tight anniversary__story-filter-options" onChange={(e) => this.setState({sort: parseInt(e.target.value), page:1}, () => this.loadStories())} value={this.state.sort} selected={this.state.sort}>
							<option value={1}>Date added: ascending</option>
							<option value={2}>Date added: descending</option>
							<option value={3}>Total # of reactions: ascending</option>
							<option value={4}>Total # of reactions: descending</option>
						</select>
					</label>
				</div>
			</section>
			: null
		);
	}

	renderContent() {
		const stories = this.state.stories.filter(story => this.state.tab == -1 ? true : story.nWeek == this.state.tab).map(story => <StoryCard showViewAll={false} classes="story-card--all-stories" story={story} key={story.idSubmission}/>);

		return (
			<section className="anniversary__story-container">
				<Masonry className="l-margin-bottom--xl" elementType={'div'} options={this.masonryOptions} disableImagesLoaded={false}>
					{stories}
				</Masonry>
				{this.state.nStories > this.state.page * this.storiesPerPage ? 
					<div className="text--center l-margin-bottom--xl"><button className="btn btn--cta" onClick={() => this.loadMore()}>Load more stories</button></div>
				: 
					<button className="anniversary__stories-list-end" onClick={() => this.scrollTop()}>
						<p>Thank you for viewing our members' stories!</p>
						<p className="anniversary__stories-list-end-cta"><i className="fas fa-long-arrow-up l-margin-right--sm"/>Back to top</p>
					</button>
				}
			</section>
		);
	}

	scrollTop() {
		$('body, html').animate({scrollTop: 0}, 100);
	}

	loadStories(loadMore)
	{
		let weeksFilter = [this.state.tab];
		if(this.state.tab == -1)
		{
			weeksFilter = [...Array(this.currentWeek+1).keys()]
		}


		blapp.models.fetch(
			"_get_stories"
			, {
				controller: "anni.BLCAnniversary"
				, method: "getStories"
				, params: [weeksFilter, false, this.state.page, this.storiesPerPage, this.state.sort]
				, refresh: true
			}
		).then(
			(data) => {
				if (data != null) {
					let nStories = data.nStories;
					let newStories = data.stories;
					if( loadMore )
						this.setState({stories: this.state.stories.concat(newStories), nStories: nStories})
					else
						this.setState({stories: newStories, nStories: nStories})
				}
			}
		).catch(
			(err) => {
				console.log(err)
			}
		);
	}

	loadMore() {
		const {page} = this.state;

		this.setState({page: this.state.page + 1}, () => this.loadStories(true));
	}

};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<AnniversaryStories blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-main' )
						);
		blapp.refs.register( "main", elem );
	}
);
